export enum Temperature {
  Cold,
  Warm,
  Hot,
  Triggered,
}
